/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './layout/header.component.ngfactory';
import * as import2 from '../../app/layout/header.component';
import * as import3 from '../../app/services/api.service';
import * as import4 from '../../app/services/response.service';
import * as import5 from '@ngx-translate/core/src/translate.service';
import * as import6 from '../../app/services/language.service';
import * as import7 from '../../app/services/auth.service';
import * as import8 from '../../app/services/user.service';
import * as import9 from '../../app/services/company.service';
import * as import10 from '../../app/services/local-storage.service';
import * as import11 from '../../app/services/cart.service';
import * as import12 from '@angular/router';
import * as import13 from '../../$$_gendir/node_modules/angular2-notifications/src/simple-notifications.component.ngfactory';
import * as import14 from 'angular2-notifications/src/simple-notifications.component';
import * as import15 from 'angular2-notifications/src/notifications.service';
import * as import16 from '../../$$_gendir/node_modules/angular2-cookie-law/lib/cookie-law.component.ngfactory';
import * as import17 from 'angular2-cookie-law/lib/cookie-law.component';
import * as import18 from 'angular2-cookie-law/lib/cookie-law.service';
import * as import19 from '../../app/app.component';
import * as import20 from 'ng2-breadcrumb/app/components/breadcrumbService';
import * as import21 from '../../app/services/breadcrumbs.service';
import * as import22 from '@ng-idle/core/src/idle';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_AppComponent,
  data: {}
}
);
export function View_AppComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),22,'div',[[
        'id',
        'page'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'header',[[
        'class',
        'page-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-header',([] as any[]),(null as any),(null as any),(null as any),import1.View_HeaderComponent_0,import1.RenderType_HeaderComponent)),
    import0.ɵdid(245760,(null as any),0,import2.HeaderComponent,[
      import3.ApiService,
      import4.ResponseService,
      import5.TranslateService,
      import6.LanguageService,
      import7.AuthService,
      import8.UserService,
      import9.CompanyService,
      import10.LocalStorageService,
      import11.CartService,
      import12.Router
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import12.RouterOutlet,[
      import12.RouterOutletMap,
      import0.ViewContainerRef,
      import0.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'simple-notifications',([] as any[]),(null as any),(null as any),(null as any),import13.View_SimpleNotificationsComponent_0,import13.RenderType_SimpleNotificationsComponent)),
      import0.ɵdid(245760,(null as any),0,import14.SimpleNotificationsComponent,[import15.NotificationsService],{options: [
        0,
        'options'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'cookie-law',[[
        'expiration',
        '365'
      ]
      ],[[
        1,
        'seen',
        0
      ]
    ],(null as any),(null as any),import16.View_CookieLawComponent_0,import16.RenderType_CookieLawComponent)),
      import0.ɵdid(114688,(null as any),0,import17.CookieLawComponent,[import18.CookieLawService],{expiration: [
        0,
        'expiration'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['Używamy informacji zapisanych za pomocą cookie w celu zapewnienia łatwiejszego korzystania z naszej strony internetowej, bezpieczeństwa użytkowania systemu oraz dostosowania jej do indywidualnych potrzeb użytkowników. Kontynuowanie przeglądania bez zmiany dotychczasowych ustawień oznacza wyrażenie zgody na otrzymywanie wszystkich plików cookies zamieszczonych na stronie. Pamiętaj, że zawsze możesz zmienić te ustawienia za pomocą programu służącego do obsługi Internetu.'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import19.AppComponent = v.component;
    ck(v,7,0);
    const currVal_0:any = co.options;
    ck(v,16,0,currVal_0);
    const currVal_2:any = '365';
    ck(v,21,0,currVal_2);
  },(ck,v) => {
    const currVal_1:any = import0.ɵnov(v,21).seen;
    ck(v,20,0,currVal_1);
  });
}
function View_AppComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-root',([] as any[]),(null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
    import0.ɵdid(4833280,(null as any),0,import19.AppComponent,[
      import5.TranslateService,
      import7.AuthService,
      import3.ApiService,
      import12.Router,
      import20.BreadcrumbService,
      import21.BreadcrumbsService,
      import5.TranslateService,
      import22.Idle
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:import0.ComponentFactory<import19.AppComponent> = import0.ɵccf('app-root',import19.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts